import moment from 'moment';
import parsePhoneNumber from 'libphonenumber-js';

export const errorLogEnabled = false

export const logEnabled = false

export const getCookies = () => {
  return document.cookie.split(';').reduce((acc, cookie) => {
    const [key, value] = cookie.trim().split('=');
    acc[key] = value;
    return acc;
  }, {});
}

export const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/; SameSite=None; Secure`;
  return value;
}

export const generateSessionId = (length = 32) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let sessionId = '';
  for (let i = 0; i < length; i++) {
    sessionId += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return sessionId;
}

// Format duration from seconds to minutes:seconds format
export const formatDurationFromSeconds = (seconds) => {
  if (!seconds && seconds !== 0) return '0:00';
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
}

export const formatDurationFromDates = (serverDate, localDate, serverTimeOffset) => {
  if (!serverDate || !localDate) return '0:00';
  let durationSeconds = Math.floor(Math.abs(localDate - serverDate + serverTimeOffset) / 1000);
  return formatDurationFromSeconds(durationSeconds);
}

export const formatDateTime = (epochTime, serverTimeOffset) => {
  return moment(epochTime + serverTimeOffset, 'x').format('YYYY-MM-DD H:mm:ss');
}

export const formatTime = (epochTime, serverTimeOffset) => {
  return moment(epochTime + serverTimeOffset, 'x').format('H:mm:ss');
}

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  const parsedNumber = parsePhoneNumber(phoneNumber);
  if (parsedNumber) return parsedNumber.formatInternational();
  return phoneNumber;
}

export const isPhoneNumberValid = (phoneNumber) => {
  if (!phoneNumber) return false;
  const parsedNumber = parsePhoneNumber(phoneNumber);
  return parsedNumber && parsedNumber.isValid();
}

export const getCallRemoteNumber = (call, availableLines) => {
  const { callType, callerNumber, calledNumber } = call;

  if (callType === 'inbound') return callerNumber;
  if (callType === 'outbound') return calledNumber;

  if (availableLines) {
    const isCallerKnown = availableLines.some(line => line.number === callerNumber);
    const isCalledKnown = availableLines.some(line => line.number === calledNumber);
    return isCallerKnown !== isCalledKnown ? (isCallerKnown ? calledNumber : callerNumber) : calledNumber;
  }

  return calledNumber;
}

export const getCallRemoteName = (call, availableLines) => {
  const { callType, callerName, calledName } = call;

  if (callType === 'inbound') return callerName;
  if (callType === 'outbound') return calledName;

  if (availableLines) {
    const isCallerKnown = availableLines.some(line => line.number === callerName);
    const isCalledKnown = availableLines.some(line => line.number === calledName);
    return isCallerKnown !== isCalledKnown ? (isCallerKnown ? calledName : callerName) : calledName;
  }

  return '';
}

export const getSmsRemoteNumber = (sms) => {
  const { sender, recipient, state } = sms;

  if (state === 'received') return sender;
  return recipient;
}

export const getTextColorClassName = (notification) => {
  if (!notification) return '';
  if (notification.event.callType) return 'with-text-color-call-' + notification.pipedriveData?.callPhase.toLowerCase();
  return 'with-text-color-sms-' + notification.event.state.toLowerCase();
}

export const getBgColorClassName = (notification) => {
  if (!notification) return '';
  if (notification.event.callType) return 'with-bg-color-call-' + notification.pipedriveData?.callPhase.toLowerCase();
  return 'with-bg-color-sms-' + notification.event.state.toLowerCase();
}

export const supportedLanguages = [ 'en', 'cs' ];

export const getCookieLanguage = () => {
  const cookies = getCookies();
  return supportedLanguages.includes(cookies.language) ? cookies.language : 'en';
}

export const setCookieLanguage = (language) => {
  if (supportedLanguages.includes(language)) {
    setCookie('language', language, 365);
  } else {
    errorLogEnabled && console.error(`Language ${language} is not supported.`);
  }
}